<template>
  <button
    type="button"
    class="action-card"
    :class="`action-card--${variant}`"
    :data-analytics-skip="selectTracked ? '' : null"
    @click="$emit('select')"
  >
    <span class="action-card__icon" aria-hidden="true">
      <v-icon class="action-card__glyph">{{ icon }}</v-icon>
    </span>

    <span class="action-card__content">
      <span class="action-card__title">{{ $t(titleToken) }}</span>
      <span v-if="descriptionToken" class="action-card__description">
        {{ $t(descriptionToken) }}
      </span>
    </span>

    <v-icon class="action-card__chevron">{{ chevronForward }}</v-icon>
  </button>
</template>

<script>
  import icons from '@/mixins/icons'
  import './styles/action-card.css'

  export default {
    name: 'ActionCard',
    mixins: [icons],
    props: {
      icon: {
        type: String,
        required: true,
      },
      titleToken: {
        type: String,
        required: true,
      },
      descriptionToken: {
        type: String,
        default: '',
      },
      selectTracked: {
        type: Boolean,
        default: false,
      },
      variant: {
        type: String,
        default: 'light',
        validator: (value) => ['light', 'dark'].includes(value),
      },
    },
  }
</script>

